import { NgModule } from '@angular/core';
import { RouterModule, Routes } from '@angular/router';

const routes: Routes = [
  {
    path: '',
    redirectTo: 'home',
    pathMatch: 'full',
    data: { breadcrumb: 'HOME' },
  },

  {
    path: 'home',
    loadChildren: () =>
      import('./home/home.module').then((m) => m.HomePageModule),
  },
  {
    path: 'invitation',
    loadChildren: () =>
      import('./invitation/invitation.module').then(
        (m) => m.InvitationPageModule
      ),
    data: {
      breadcrumb: 'MENU.YOUR_INVITATIONS',
    },
  },
  {
    path: 'settings',
    loadChildren: () =>
      import('./settings/settings.module').then((m) => m.SettingsPageModule),
    data: {
      breadcrumb: 'SETTINGS.SETTING',
    },
  },
  {
    path: 'company',
    loadChildren: () =>
      import('./company/company.module').then((m) => m.CompanyPageModule),
    data: {
      breadcrumb: 'MENU.COMPANIES',
    },
  },
  {
    path: 'users',
    loadChildren: () =>
      import('./users/users.module').then((m) => m.UsersPageModule),
    data: {
      breadcrumb: 'MENU.USERS',
    },
  },
  {
    path: 'info',
    loadChildren: () =>
      import('./info/info.module').then((m) => m.InfoPageModule),
  },
  {
    path: 'report',
    loadChildren: () =>
      import('./report/report.module').then((m) => m.ReportPageModule),
    data: {
      breadcrumb: 'MENU.REPORTS',
    },
  },
  {
    path: 'building',
    loadChildren: () =>
      import('./building/building.module').then((m) => m.BuildingPageModule),
    data: {
      breadcrumb: 'MENU.BUILDINGS',
    },
  },

  {
    path: 'community',
    loadChildren: () =>
      import('./community/community.module').then((m) => m.CommunityPageModule),
    data: {
      breadcrumb: 'MENU.LATEST_NEWS',
    },
  },
  {
    path: 'message',
    loadChildren: () =>
      import('./message/message.module').then((m) => m.MessagePageModule),
  },
  {
    path: 'market',
    loadChildren: () =>
      import('./market/market.module').then((m) => m.MarketPageModule),
    data: {
      breadcrumb: 'MENU.MARKET_PLACE',
    },
  },
  {
    path: 'report-task',
    loadChildren: () =>
      import('./report/report-task/report-task.module').then(
        (m) => m.ReportTaskPageModule
      ),
    data: {
      breadcrumb: 'MENU.TASKS',
    },
  },
  // {
  //   path: "calendar",
  //   loadChildren: () =>
  //     import("./../_component/calendar/calendar.module").then(
  //       (m) => m.CalendarPageModule
  //     ),
  //     // Do weryfikacji czy jest potrzebne
  // },
  {
    path: 'parking',
    loadChildren: () =>
      import('./parking/parking.module').then((m) => m.ParkingPageModule),
    data: {
      breadcrumb: 'MENU.PARKING',
    },
  },
  {
    path: 'booking',
    loadChildren: () =>
      import('./booking/room/room.module').then((m) => m.RoomPageModule),
    data: {
      breadcrumb: 'MENU.BOOKING',
    },
  },
  {
    path: 'booking/my-reservation',
    loadChildren: () =>
      import('./booking/room/room.module').then((m) => m.RoomPageModule),
    data: {
      breadcrumb: 'SPACE.MY_RESERVATIONS',
    },
  },
  {
    path: 'booking/:IdRoom',
    loadChildren: () =>
      import('./booking/booking.module').then((m) => m.BookingPageModule),
    // data: {
    //   breadcrumb: {
    //     label: "MENU.BOOKING",
    //   },
    // },
  },
  {
    path: 'first-run',
    loadChildren: () =>
      import('./first-run/first-run.module').then((m) => m.FirstRunPageModule),
  },
  {
    path: 'equipment/:spaceType',
    loadChildren: () =>
      import('./equipment/equipment.module').then((m) => m.EquipmentPageModule),
    data: {
      breadcrumb: 'SPACE.ROOM.EQUIPMENT',
    },
  },
  {
    path: 'integration-trip',
    loadChildren: () =>
      import('./integration-trip/integration-trip.module').then(
        (m) => m.IntegrationTripPageModule
      ),
    data: {
      breadcrumb: 'MENU.INTEGRATION_LOCATION',
    },
  },
  {
    path: 'debug',
    loadChildren: () =>
      import('./../debug/debug.module').then((m) => m.DebugPageModule),
  },
  {
    path: 'desk',
    loadChildren: () =>
      import('./desk/desk.module').then((m) => m.DeskPageModule),
  },
  {
    path: 'rental',
    loadChildren: () =>
      import('./rental/rental.module').then((m) => m.RentalPageModule),
    data: {
      breadcrumb: 'MENU.RENTAL',
    },
  },
  {
    path: 'administrator',
    loadChildren: () =>
      import('./administrator/administrator.module').then(
        (m) => m.AdministratorPageModule
      ),
    data: {
      breadcrumb: 'MENU.ADMIN',
    },
  },
  {
    path: 'disabled/:module',
    loadChildren: () =>
      import('./disabled/disabled.module').then((m) => m.DisabledPageModule),
  },
  {
    path: 'practices-list',
    loadChildren: () => 
      import('./practices-list/practices-list.module').then( 
        m => m.PracticesListPageModule
      ),
      data: {
        breadcrumb: 'MENU.PRACTICES_LIST'
      }
  },

];

@NgModule({
  imports: [RouterModule.forChild(routes)],
  exports: [RouterModule],
})
export class AppRoutingModule {}
